export const push = () => {
  const state = window.history.state;
  if (state && state.popup) return;

  window.history.pushState({ popup: true }, '');
};

export const pop = () => {
  const state = window.history.state;
  if (!state || !state.popup) return;

  window.history.back();
};
